<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" small color="primary" class="ml-1">
        mdi-calendar-star
      </v-icon>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
//11180 - marks a service that was copied from an open group departure date
export default {
  name: "FromDepartureIcon",
  props: {
    label: {
      type: String,
      default: "Added from the departure date",
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/FromDepartureIcon.vue